import React from "react"

const SearchGroupList = ({ searchGroup, results }) => {
  return (
    <div className="col-">
      <h5>{searchGroup}</h5>
      <ul className="list-group">
        {results.map((result, index) => (
          <li className="list-group-item" key={index}>
            {result.parts.map((part, index) => {
              const className = part.highlight ? "query" : null
              return (
                <span className={className} key={index}>
                  {part.text}
                </span>
              )
            })}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default SearchGroupList
